<template>
  <div class="w-100">
    <span class="bolder">{{ text }}</span>
    <span class="valueField">
      <b>{{ value }}</b>
    </span>
  </div>
</template>

<script>
export default {
  name: 'CustomSelectedOption',
  meta: {
    description: 'Componente para opciones seleccionadas',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    text: {
      type: String,
      default: '',
      meta: {
        description: 'Mensaje mostrado en el interior del componente',
        example: 'Texto requerido',
      },
    },
    value: {
      type: String,
      default: '',
      meta: {
        description: 'Parámetro de entrada del CustomSelectedOption',
        example: 'Texto requerido',
      },
    },
  },
};
</script>

<style scoped>
div {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  opacity: 1;
  font: 400 16px/21px Lato;
  color: #3f5b60;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}
span.bolder {
  font-weight: 700;
}

.valueField {
  margin-left: 8px;
}
</style>
